import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash, FaHashtag, FaUser, FaPhoneAlt } from "react-icons/fa";
import axios from 'axios';
import { MdEmail } from "react-icons/md";
import { Modal, ModalBody } from "flowbite-react";
import "react-datepicker/dist/react-datepicker.css";
import "../../CSS/Calander.css";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';

const ProfileSettings = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [adminData, setAdminData] = useState([]);
  const [resetPassword, setResetPassword] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [formData, setFormData] = useState({
    id: '',
    username: '',
    contactNumber: '',
    email: ''
  });

  const navigate = useNavigate();

  const fetchAdminData = () => {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      localStorage.clear();
      navigate('/AdminLogin');
    } else {
      axios.get('https://backend.amarasinghemedicare.com/admin/details', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          const data = response.data;
          setAdminData(data);
          localStorage.setItem("adminName", data.UserName);

          setFormData({
            id: data.id,
            username: data.UserName,
            contactNumber: data.contactNumber,
            email: data.email
          });
        })
        .catch((error) => {
          console.error('Error in fetching data :', error);
        });
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    try {
      const newPassword = resetPassword.newPassword;
      const confirmPassword = resetPassword.confirmPassword;

      if (newPassword !== confirmPassword) {
        toast.error("Confirm password is not matched!");
        return;
      } else {
        const token = localStorage.getItem('adminToken');

        const response = await axios.patch('https://backend.amarasinghemedicare.com/admin/password',
          {
            data: resetPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          toast.success(response.data.message);
          setIsPasswordModalOpen(false);
          setResetPassword({
            currentPassword: '',
            confirmPassword: '',
            newPassword: ''
          });
        } else {
          toast.error(response.message);
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setIsPasswordModalOpen(false);
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value })
  };

  const handleResetChanges = (e) => {
    const { name, value } = e.target;
    setResetPassword({ ...resetPassword, [name]: value })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.patch('https://backend.amarasinghemedicare.com/admin/edit', {
        data: formData
      });

      if (response.status !== 200) {
        toast.error("Something went wrong!");
      } else {
        toast.success("Profile details updated successfully!");
        setFormData({
          id: '',
          contactNumber: '',
          email: '',
          username: ''
        });
        fetchAdminData();
        setIsEditModalOpen(false);
      }
    } catch (error) {
      console.error('Submit error:', error);
      toast.error("Error in submitting data!");
    }
  };

  return (
    <div className="mt-0">
      <Toaster />

      <div className="mt-0">

        {/* Profile Details */}
        <main className="mt-0">
          <h3 className="text-xl font-bold text-gray-800 mb-5">
            Admin Details
          </h3>

          <table class="table-auto border-collapse">
            <tbody>
              <tr>
                <td class="p-2 flex justify-start items-center gap-3"><FaHashtag />Admin ID</td>
                <td class="p-2">{adminData.id}</td>
              </tr>
              <tr>
                <td class="p-2 flex justify-start items-center gap-3"><FaUser /> Username</td>
                <td class="p-2">{adminData.UserName}</td>
              </tr>
              <tr>
                <td class="p-2 flex justify-start items-center gap-3"><FaPhoneAlt /> Contact Number</td>
                <td class="p-2">{adminData.contactNumber}</td>
              </tr>
              <tr>
                <td class="p-2 flex justify-start items-center gap-3"><MdEmail /> Email Address</td>
                <td class="p-2">{adminData.email}</td>
              </tr>
            </tbody>
          </table>
        </main>
      </div>

      <div className="mt-10">
        <h4 className="text-lg font-bold text-gray-800 mb-2">Privacy Settings</h4>
        <div className="flex gap-5">
          <button
            onClick={() => setIsEditModalOpen(true)}
            className="mt-5 bg-[#161D6F] w-auto px-20 py-2 text-white rounded font-medium hover:bg-blue-600 transition"
          >
            Edit details
          </button>

          <button
            onClick={() => setIsPasswordModalOpen(true)}
            className="mt-5 bg-[#161D6F] w-auto px-14 py-2 text-white rounded font-medium hover:bg-blue-600 transition"
          >
            Change Password
          </button>
        </div>
      </div>

      <Modal size="md" show={isEditModalOpen} onClose={handleModalClose} popup>
        <Modal.Header className="bg-white" />
        <Modal.Body className="bg-white">
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900"><span className='text-red'>Edit</span> Admin Details</h3>
            <form onSubmit={handleSubmit}>
              <input type="hidden" name="id" id='id' value={formData.id} />
              <div>
                <label htmlFor="" className='text-xs'>Admin Username</label>
                <input type="text" id='username' name='username' value={formData.username} onChange={handleChanges} className='w-[100%] h-9 bg-[#d8dad8] rounded-md p-3 text-xs' required />
              </div>

              <div>
                <label htmlFor="" className='text-xs'>Contact Number</label>
                <input type="type" id='contactNumber' name='contactNumber' value={formData.contactNumber} onChange={handleChanges} className='w-[100%] h-9 bg-[#d8dad8] rounded-md p-3 text-xs' required />
              </div>

              <div>
                <label htmlFor="" className='text-xs'>Email</label>
                <input type="type" id='email' name='email' value={formData.email} onChange={handleChanges} className='w-[100%] h-9 bg-[#d8dad8] rounded-md p-3 text-xs' required />
              </div>

              <div className='bg-red p-2 rounded-md my-5'>
                <p className='text-xs text-white'>warning ! Make sure everything saved.</p>
              </div>

              <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                <button onClick={handleModalClose} className='text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Cancel</button>
                <button type='submit' className='text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Save</button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" show={isPasswordModalOpen} onClose={handleModalClose} popup>
        <Modal.Header className="bg-white" />
        <Modal.Body>
          
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfileSettings;